import { loadScript } from '@/lib/utils'
import Head from 'next/head'
import React, { useEffect } from 'react'

export const GA = () => {
  useEffect(() => {
    setTimeout(() => {
      loadScript('https://www.googletagmanager.com/gtag/js?id=UA-135444739-2')
    }, 0)
  }, [])

  return (
    <Head>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-135444739-2');`,
        }}
      ></script>
    </Head>
  )
}
